import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/propose", label: "Suggest a Gathering" },
  { to: "/copartner", label: "Partner with us" },
  { to: "/join", label: "Host with us" },
  { to: "/about", label: "Our Story" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-xl"
      style={{
        background: "rgba(250, 248, 245, 0.78)",
        borderBottom: "1px solid var(--line)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-baseline gap-2"
        >
          <span className="font-serif text-3xl tracking-tight" style={{ color: "var(--text-main)" }}>
            saamne
          </span>
          <span className="label-eyebrow hidden sm:inline">/ Curated In-Person Experiences</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm transition-colors duration-300 ${
                  isActive ? "text-[color:var(--primary)]" : "text-[color:var(--text-main)] hover:text-[color:var(--primary)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href="#rsvp"
            data-testid="nav-cta"
            className="btn-primary ml-3 text-sm"
            style={{ padding: "0.55rem 1.25rem" }}
          >
            I'm Interested
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden btn-ghost"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="md:hidden px-6 pb-6 flex flex-col gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3 py-3 rounded-2xl ${
                  isActive ? "bg-[color:var(--surface)] text-[color:var(--primary)]" : "text-[color:var(--text-main)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}
